// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-control/MissionControlSection.jsx

import React from "react";

export default function MissionControlSection({
  eyebrow,
  title,
  description,
  actions,
  children,
  className = "",
}) {
  return (
    <section className={`mission-control-section ${className}`.trim()}>
      <header className="mission-control-section__header">
        <div>
          {eyebrow ? (
            <span className="mission-control-section__eyebrow">
              {eyebrow}
            </span>
          ) : null}
          <h2>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
        {actions ? (
          <div className="mission-control-section__actions">{actions}</div>
        ) : null}
      </header>
      <div className="mission-control-section__body">{children}</div>
    </section>
  );
}
